import React, { Fragment } from 'react'
import Back from '../../../../shared/components/Icons/Back';
import Styled from './styles';
import useTableSelectorBack from '../../../../hooks/useTableSelectorBack';

interface TableSelectorBackProps {
  sector?: {
    label: string;
  };
}

const TableSelectorBack = ({ sector }: TableSelectorBackProps) => {
  const { t, transliterate, resetSector } = useTableSelectorBack();

  return (
    <Fragment>
      <Styled.BackButton onClick={resetSector} type="button" data-selenium="back">
        <Back /> {t('back')}
      </Styled.BackButton>
      {sector ? <Styled.SectorName>{transliterate(sector.label)}</Styled.SectorName> : null}
    </Fragment>
  );
};

export default TableSelectorBack;
